define([
    "./microstrategyModule",
    "./microstrategyController",
    "./nlgMicroStrategy",
    "./microstrategyServiceUrl",
    "./microstrategyService"
], function () {
});